import { AppRouter } from "@app/router";
import { LoginScreen } from "@features/auth/LoginScreen";
import { getProdToken, isProdAuthEnabled } from "@api/prodAuth";

/**
 * Top-level render-gate. When prod-auth is enabled and the app holds NO token
 * (a deliberate logout, or a login that hasn't happened yet), render the login
 * screen instead of the app. In every other mode — dev-auth, MSW mocks, or
 * prod-auth with a live token — render the app router as before.
 *
 * The decision is made once at mount: `initProdAuth` has already run (and been
 * awaited) by the time this renders, so `getProdToken()` reflects the final
 * boot state. Login and "continue as demo" both reload the page, so there is no
 * need to subscribe to token changes here — the gate re-evaluates on reload.
 * Logout likewise reloads (see SettingsMenu), landing back on this gate with no
 * token → the login screen.
 */
export function AppGate() {
  if (isProdAuthEnabled() && !getProdToken()) {
    return <LoginScreen />;
  }
  return <AppRouter />;
}
